module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "LMSGpage"
  }, [_c('div', {
    staticClass: "styleExplanation",
    staticStyle: {
      "padding": "15px"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('iframe_page.form_explanation')) + "\n    "), _c('div', {
    staticClass: "styleAllowFormats",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('iframe_page.allowed_formats')) + "\n    ")]), _vm._v(" "), (_vm.showDocumentTypeForm('Status')) ? _c('document-type-form', {
    attrs: {
      "multipleDocs": "",
      "docType": "Status",
      "idDocument": _vm.statusIdDocs,
      "name": "docTypeFormStatus",
      "subTitle": _vm.$t('iframe_page.docdesc.status'),
      "title": _vm.$t('iframe_page.doctypes.status')
    },
    model: {
      value: (_vm.statusDocs),
      callback: function($$v) {
        _vm.statusDocs = $$v
      },
      expression: "statusDocs"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('iframe_page.docinfo.status')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.showDocumentTypeForm('RIB')) ? _c('document-type-form', {
    attrs: {
      "docType": "RIB",
      "ocr": "",
      "idDocument": _vm.ribIdDocs,
      "name": "docTypeFormRIB",
      "title": _vm.$t('iframe_page.doctypes.rib'),
      "subTitle": _vm.$t('iframe_page.docdesc.rib')
    },
    model: {
      value: (_vm.ribDocs),
      callback: function($$v) {
        _vm.ribDocs = $$v
      },
      expression: "ribDocs"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('iframe_page.docinfo.rib')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.showDocumentTypeForm('KBIS')) ? _c('document-type-form', {
    attrs: {
      "multipleDocs": "",
      "docType": "KBIS",
      "idDocument": _vm.kbisIdDocs,
      "informations": _vm.$t('iframe_page.docinfo.kbis'),
      "name": "docTypeFormKBIS",
      "title": _vm.$t('iframe_page.doctypes.kbis'),
      "subTitle": _vm.$t('iframe_page.docdesc.kbis')
    },
    model: {
      value: (_vm.kbisDocs),
      callback: function($$v) {
        _vm.kbisDocs = $$v
      },
      expression: "kbisDocs"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('iframe_page.docinfo.kbis')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.showDocumentTypeForm('IDCARD')) ? _c('document-type-form', {
    attrs: {
      "multipleDocs": "",
      "docType": "IDCARD",
      "idDocument": _vm.PIIdDocs,
      "name": "docTypeFormPIMain",
      "title": _vm.$t('iframe_page.doctypes.id'),
      "subTitle": _vm.$t('iframe_page.docdesc.id')
    },
    model: {
      value: (_vm.PIDocs),
      callback: function($$v) {
        _vm.PIDocs = $$v
      },
      expression: "PIDocs"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('iframe_page.docinfo.id_1'))), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "pr-2"
  }), _vm._v(_vm._s(_vm.$t('iframe_page.docinfo.id_2'))), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "pr-2"
  }), _vm._v(_vm._s(_vm.$t('iframe_page.docinfo.id_3'))), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "pr-2"
  }), _vm._v(_vm._s(_vm.$t('iframe_page.docinfo.id_4'))), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "pr-2"
  }), _vm._v(_vm._s(_vm.$t('iframe_page.docinfo.id_5')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.showDocumentTypeForm('UBO')) ? _c('document-type-form', {
    attrs: {
      "docType": "UBO",
      "name": "docTypeFormUBO",
      "title": _vm.$t('iframe_page.doctypes.shareholder'),
      "subTitle": _vm.$t('iframe_page.what_shareholder_declaration_is')
    },
    model: {
      value: (_vm.uboDocs),
      callback: function($$v) {
        _vm.uboDocs = $$v
      },
      expression: "uboDocs"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('iframe_page.declaration_it_is_1')) + " "), _c('b', [_vm._v(_vm._s(_vm.$t('iframe_page.declaration_it_is_2')))]), _vm._v(" "), _c('br'), _vm._v(" " + _vm._s(_vm.$t('iframe_page.declaration_it_is_3')) + " " + _vm._s(_vm.$t('iframe_page.declaration_it_is_4')) + "\n    ")]) : _vm._e()], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-994d034e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-994d034e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LMSGiframe/components/DocumentMainView.vue
// module id = 2427
// module chunks = 2